<template>
  <div>
    <!-- 配送单拆分 -->
    <el-dialog :title="$t('message.distributionOrderSplitting')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="1480px" center>
      <div class="content">
        <h6>
          注意：拆分后箱子编号会重新排序，原来贴的箱子唛头需要重新打印黏贴。
        </h6>
        <!-- 按配送单分 -->
        <div class="porder" v-for="(item, index) in tableData" :key="index">
          <!-- 配送单 -->
          <p>{{ $t("message.porder") }}: {{ item.porder_sn }}</p>
          <!-- 箱子列表 -->
          <div class="list">
            <!-- 拆分到单个箱子 -->
            <div class="item">
              <el-table :data="item.new" border :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%">
                <!-- NO -->
                <el-table-column type="index" label="NO" align="center" width="50"></el-table-column>
                <!--  拆分到新配送单箱子编号-->
                <el-table-column property="porder_freight.porder_sn" label="拆分到新配送单箱子编号" align="center"
                  prop="number"></el-table-column>
                <!-- 箱规 -->
                <el-table-column label="箱规" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.length }}* {{ scope.row.width }}*
                    {{ scope.row.height }}
                  </template>
                </el-table-column>
                <!-- 重量 -->
                <el-table-column property="num" label="重量" align="center" width="70" prop="weight"></el-table-column>
                <!-- 对应新配送单箱子编号 -->
                <el-table-column property="num" label="对应新配送单箱子编号" align="center" prop="number_new"></el-table-column>
              </el-table>
            </div>
            <!-- 拆分前单个箱子 -->
            <div class="item">
              <el-table :data="item.old" border :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%">
                <!-- NO -->
                <el-table-column type="index" label="NO" align="center" width="50"></el-table-column>
                <!--  当前配送单剩下箱子编号-->
                <el-table-column property="porder_freight.porder_sn" label="当前配送单剩下箱子编号" align="center"
                  prop="number"></el-table-column>
                <!-- 箱规 -->
                <el-table-column property="porder_freight.number" label="箱规" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.length }}* {{ scope.row.width }}*
                    {{ scope.row.height }}
                  </template>
                </el-table-column>
                <!-- 重量 -->
                <el-table-column property="num" label="重量" align="center" width="70" prop="weight"></el-table-column>
                <!-- 拆分后剩下箱子新编号 -->
                <el-table-column property="num" label="拆分后剩下箱子新编号" align="center" prop="number_new"></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <!-- <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button> -->
        <!-- 确认拆分 -->
        <el-button type="primary" @click="splitPorderConfirmed">{{
          $t("message.confirmTheSplit")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    porder_sn: { type: String },
  },
  data() {
    return {
      dialogVisible: false,
      freightDetailData: [],
      tableData: [],
    };
  },
  computed: {
    ...mapState({
      boxIds: (state) => state.porderDetail.boxIds,
    }),
  },
  methods: {
    // 配送单-待报价-拆单(待报价)
    splitPorderConfirmed() {
      this.$api.porderApi
        .splitPorderConfirmed({
          freight_ids: this.boxIds,
        })
        .then((res) => {
          this.$alert("新配送单号：" + res.data, "提示", {
            confirmButtonText: "确定",
            center: true,
          });
          this.dialogVisible = false
          let datas = {
            porder_sn: this.$route.query.porder_sn,

          }
          this.$store.dispatch("porderDetail", datas)

          // 配送单-校验其他费用差值
          this.$api.porderApi
            .checkPorderOtherFee(datas).then(res => {
              if (!res.data.is_match) {
                this.$alert("配送单调整后，当前其他费用与该收费用对不上，请检查其他费用是否正确！！！", "提示", {
                  confirmButtonText: "确定",
                  center: true,
                });
              }
            })


        });
    },
    //拆单箱号预览
    splitPorderConfirmedPreview() {
      let datas = {
        freight_ids: this.boxIds,
      };
      this.$api.porderApi.splitPorderConfirmedPreview(datas).then((res) => {
        this.tableData = res.data;
        console.log(res);
      });
    },
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.splitPorderConfirmedPreview();
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  h6 {
    color: #b4272d;
  }

  .porder {
    margin-top: 20px;

    .list {
      display: flex;

      .item {
        width: 680px;
        margin-right: 19px;
        margin-top: 20px;

        &:nth-child(2n) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>